export default "I er en gruppe tyve, og jeres mål er et kasino i København. Kan I få adgang til pengeskabet og dets indhold, inden politiet ankommer?";